module.exports = __webpack_public_path__ + "img/bg_impenmention_light.15647d67.png";